import {
  type EntityLoadRecord,
  loadListByEntityQueryAtom,
} from '@rematter/modules/customer-portal/_graphql/queryLoadListByEntity';
import type { Atom } from 'jotai';
import { atom } from 'jotai';

import { customerPortalRoutes as routes } from '../routes';
import { EntityLoadDetailsTab } from '../types';

import type { QueryAtomReadValue } from '~/shared/providers/api/createQueryAtomFactory';
import { atomFromQueryString, atomFromRoutePath } from '~/shared/state';

// 🟣🟣🟣 PARAMS
const $purchaseOrderParams = atomFromRoutePath(routes.purchaseOrderDetails);
const $bookingParams = atomFromRoutePath(routes.bookingDetails);

// prettier-ignore
export const $purchaseOrderId = atom((get) => get($purchaseOrderParams)?.purchaseOrderId);
export const $bookingId = atom((get) => get($bookingParams)?.bookingId);

// prettier-ignore
export const $loadTab = atomFromQueryString.string<EntityLoadDetailsTab>('loadTab');
export const $searchTerm = atomFromQueryString.string<string>('q');
export const $selectedLoadId = atomFromQueryString.string<string>('loadId');

// 🟢🟢🟢 REMOTE DATA
export const $remoteEntityLoads = loadListByEntityQueryAtom((get) => ({
  variables: {
    bookingIds: get($bookingId),
    purchaseOrderId: get($purchaseOrderId),
  },
  skip: !get($bookingId) && !get($purchaseOrderId),
}));

export const $allEntityLoads = atom((get) => {
  const { data: entityLoads = [] } = get($remoteEntityLoads);
  return entityLoads;
});

// 🟢🟢🟢 COMPUTED DATA
export const $filteredEntityLoads: Atom<
  QueryAtomReadValue<EntityLoadRecord[]>
> = atom((get) => {
  const searchTerm = get($searchTerm)?.toLowerCase();
  const { data: entityLoads = [], ...remoteLoads } = get($remoteEntityLoads);

  const filteredLoads = entityLoads.filter(
    (it) => !searchTerm || String(it.loadNumber).includes(searchTerm),
  );

  return { ...remoteLoads, data: filteredLoads };
});
